<template>
  <div class="pageContent">
    <add ref="add" :IsShow="2" :LM="true" @setConfig="setConfig"></add>
  </div>
</template>
<script>
import add from "@/views/apply/newVip/card/vip/add";
import { mapGetters } from "vuex";
import { platformcard_set_card } from "@/api/platform_card";

export default {
  components: {
    add
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      resource:''
    };
  },
  methods: {
    async setConfig(data) {
      let is_mutex = this.$refs.add.mutex.join(",");
      console.log("shuju", is_mutex);
      let datas = {
        app_id: this.app_id,
        id: this.$route.query.id,
        ...data,
        is_mutex: is_mutex
      };
      console.log(datas);
      const res = await platformcard_set_card(datas);
      if (res.code == 200) {
        this.$message.success(res.msg);
        // this.$refs.add.set_card_info();
        this.$router.push('/apply/newVip/13/card/activityCard/index')
      } else {
        this.$message.error(res.msg);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.pageContent {
  height: 100%;
  overflow: auto;
}
</style>
